import ShareSocial from './ShareSocial';

export default ShareSocial;
